import * as firebase from "./firebase"
import { getFirestore, 
    collection, getDocs, addDoc, setDoc, doc, 
    updateDoc, getDoc, query, where, DocumentReference,
    deleteDoc, serverTimestamp, Timestamp
} from "firebase/firestore"
import store from './store';

export const db=getFirestore(firebase.firebaseApp);

async function addFieldsDefault(dates) {
    dates['timestamp']=serverTimestamp();
    dates['user']=store.state.user.id;
    console.log(dates);
}

export async function getForeignCollection(object_list,keys=[]) {
    for(var z=0;z<keys.length;z++) {
        var foreign=await db.getCollection(keys[z]);
        for(var i=0;i<object_list.length;i++) {
            for(var j=0;j<foreign.length;j++) {
                if (object_list[i][keys[z]]==foreign[j].id) {
                    object_list[i][keys[z]+'_obj']=foreign[j];
                }
            }
        }
    }
    return object_list;
}

export async function getCollection(nameCollection) {
    var res=JSON.parse(localStorage.getItem(nameCollection) || '[]');
    var res=[];
    if (res.length==0) {
    //if (true) {
        //console.log("No habia datos");
        const querySnapshot = await getDocs(collection(db,nameCollection));
        await querySnapshot.forEach(async (element) => {
            var data=element.data();
            data['id']=element.id;
            res.push(data);
        });
        localStorage.setItem(nameCollection+"TIME",new Date());
    } else {
        //console.log("Habian datos");
        var lastGetCollection=new Date();
        if (localStorage.getItem(nameCollection+"TIME")!=null) {
            lastGetCollection=new Date(localStorage.getItem(nameCollection+"TIME"));
        }
        var news=await searchDocument(nameCollection,'timestamp','>=',Timestamp.fromDate(lastGetCollection));
        if (news.length>0) {
            //console.log("Documentos Actualizados");
            localStorage.setItem(nameCollection+"TIME",new Date());
            await news.forEach(element => {
                var find=false;
                for(var i=0;i<res.length;i++) {
                    if (element.id==res[i].id) {
                        res[i]=element;
                        find=true;
                    }
                }
                if (!find) {
                    res.push(element);
                }
            });
        }
    }
    localStorage.setItem(nameCollection,JSON.stringify(res));
    return res;
}

export async function getDocument(nameCollection,idDocument,def={nombre:null}) {
    const docRef = doc(db, nameCollection, idDocument);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        //console.log("Document data:", docSnap.data());
        var data=docSnap.data();
        data['id']=docSnap.id;
        /*Object.entries(data).forEach((key,value) => {
            if (data[key[0]] instanceof Object) {
                data[key[0]+"_obj"]=getDoc(key[1]).data();
            }
        });*/
        return data;
    } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
        return def;
    }
}

export async function searchDocument(nameCollection,field,operator,value) {
    const citiesRef = collection(db, nameCollection);
    const q = query(citiesRef, where(field,operator,value));
    const querySnapshot = await getDocs(q);
    var res=[];
    await querySnapshot.forEach(async (element) => {
        var data=element.data();
        data['id']=element.id;
        res.push(data);
    });
    return res;
}

export async function searchDocument2(nameCollection,field,operator,value,field2,operator2,value2) {
    const citiesRef = collection(db, nameCollection);
    const q = query(citiesRef, where(field,operator,value),where(field2,operator2,value2));
    const querySnapshot = await getDocs(q);
    var res=[];
    await querySnapshot.forEach(async (element) => {
        var data=element.data();
        data['id']=element.id;
        res.push(data);
    });
    return res;
}

export async function searchDocument3(nameCollection,field,operator,value,field2,operator2,value2,field3,operator3,value3) {
    const citiesRef = collection(db, nameCollection);
    const q = query(citiesRef, 
        where(field,operator,value),
        where(field2,operator2,value2),
        where(field3,operator3,value3)
    );
    const querySnapshot = await getDocs(q);
    var res=[];
    await querySnapshot.forEach(async (element) => {
        var data=element.data();
        data['id']=element.id;
        res.push(data);
    });
    return res;
}

export async function addDocument(nameCollection, dates, defaultFields=true) {
    if (defaultFields) {
        await addFieldsDefault(dates);
    }
    return await addDoc(collection(db, nameCollection),dates)
    .then((doc) => {
        return doc.id
    }).catch((error) => {
        console.log(error.message);
        return false;
    });
}

export async function setDocument(nameCollection,idDocument,dates, defaultFields=true) {
    if (defaultFields) {
        await addFieldsDefault(dates);
    }
    return await setDoc(doc(db, nameCollection, idDocument), dates)
    .then((doc) => {
        return true;
    }).catch((error) => {
        console.log(error.message);
        return false;
    });
}

export async function updateDocument(nameCollection,idDocument,dates, defaultFields=true) {
    if (defaultFields) {
        await addFieldsDefault(dates);
    }
    return await updateDoc(doc(db, nameCollection, idDocument), dates)
    .then((doc) => {
        return true
    }).catch((error) => {
        console.log(error.message);
        return false;
    });
}

export async function updateDocument2(nameCollection,idDocument,dates, defaultFields=true) {
    if (defaultFields) {
        dates['timestamp']=serverTimestamp();
        dates['user_cierre']=store.state.user.id;
    }
    return await updateDoc(doc(db, nameCollection, idDocument), dates)
    .then((doc) => {
        return true
    }).catch((error) => {
        console.log(error.message);
        return false;
    });
}

export async function deleteDocument(nameCollection,idDocument) {
    var res=JSON.parse(localStorage.getItem(nameCollection) || '[]');
    if (res.length>0) {
        for( var i = 0; i < res.length; i++){ 
            if ( res[i].id == idDocument) { 
                res.splice(i, 1); 
            }
        }
    }
    localStorage.setItem(nameCollection,JSON.stringify(res));
    return await deleteDoc(doc(db, nameCollection, idDocument))
    .then((doc) => {
        return true
    }).catch((error) => {
        console.log(error.message);
        return false;
    });
}